import React from "react";
import Admin from "./Admin";
import Adminheader from "./Adminheader";
import Adminleft from "./Adminleft";
import "./App.css";

function Profile() {
  document.title='HR School - Profile'
  return (
    <div>
      <Adminheader />
      <Adminleft />
      <div className="col-md-4">
        <div className="col-md-12 padding-0 profileside">
          <div className="panel box-v2">
            <div className="panel-heading padding-0">
              <img
                src="assets/imgs/bg2.jpg"
                className="box-v2-cover img-responsive"
              />
              <div className="box-v2-detail">
                <img src="assets/imgs/avatar.png" className="img-responsive" />
                <h4>Hero Gaur</h4>
              </div>
            </div>
            <div className="panel-body">
              <div className="col-md-12 padding-0 text-center">
                <div className="col-md-4 col-sm-4 col-xs-6 padding-0">
                  <h3>2.000</h3>
                  <p>Post</p>
                </div>
                <div className="col-md-4 col-sm-4 col-xs-6 padding-0">
                  <h3>2.232</h3>
                  <p>share</p>
                </div>
                <div className="col-md-4 col-sm-4 col-xs-12 padding-0">
                  <h3>4.320</h3>
                  <p>photos</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-12 padding-0 profilesides">
          <div className="panel box-v3">
            <div className="panel-heading bg-white border-none">
              <h4>Report</h4>
            </div>
            <div className="panel-body profilesidess">
              <div className="media">
                <div className="media-left">
                  <span
                    className="icon-folder icons"
                    style={{ fontSize: "2em" }}
                  />
                </div>
                <div className="media-body">
                  <h5 className="media-heading">Upload Certificate</h5>
                  <div className="progress progress-mini">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      aria-valuenow={10}
                      aria-valuemin={0}
                      aria-valuemax={100}
                      style={{ width: "10%" }}
                    >
                      <span className="sr-only">60% Complete</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="media">
                <div className="media-left">
                  <span
                    className="icon-pie-chart icons"
                    style={{ fontSize: "2em" }}
                  />
                </div>
                <div className="media-body">
                  <h5 className="media-heading">Gallery</h5>
                  <div className="progress progress-mini">
                    <div
                      className="progress-bar progress-bar-success"
                      role="progressbar"
                      aria-valuenow={19}
                      aria-valuemin={0}
                      aria-valuemax={100}
                      style={{ width: "19%" }}
                    >
                      <span className="sr-only">60% Complete</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="media">
                <div className="media-left">
                  <span
                    className="icon-energy icons"
                    style={{ fontSize: "2em" }}
                  />
                </div>
                <div className="media-body">
                  <h5 className="media-heading">Server Optimation</h5>
                  <div className="progress progress-mini">
                    <div
                      className="progress-bar progress-bar-info"
                      role="progressbar"
                      aria-valuenow={55}
                      aria-valuemin={0}
                      aria-valuemax={100}
                      style={{ width: "55%" }}
                    >
                      <span className="sr-only">60% Complete</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="media">
                <div className="media-left">
                  <span
                    className="icon-user icons"
                    style={{ fontSize: "2em" }}
                  />
                </div>
                <div className="media-body">
                  <h5 className="media-heading">Public Review</h5>
                  <div className="progress progress-mini">
                    <div
                      className="progress-bar progress-bar-warning"
                      role="progressbar"
                      aria-valuenow={20}
                      aria-valuemin={0}
                      aria-valuemax={100}
                      style={{ width: "20%" }}
                    >
                      <span className="sr-only">60% Complete</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="media">
                <div className="media-left">
                  <span
                    className="icon-fire icons"
                    style={{ fontSize: "2em" }}
                  />
                </div>
                <div className="media-body">
                  <h5 className="media-heading">Firewall Status</h5>
                  <div className="progress progress-mini">
                    <div
                      className="progress-bar progress-bar-danger"
                      role="progressbar"
                      aria-valuenow={90}
                      aria-valuemin={0}
                      aria-valuemax={100}
                      style={{ width: "10%" }}
                    >
                      <span className="sr-only">60% Complete</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="panel-footer bg-white border-none">
              {/* <center>
                <input
                  type="button"
                  defaultValue="download as pdf"
                  className="btn btn-danger box-shadow-none"
                />
              </center> */}
            </div>
          </div>
        </div>
        <div className="col-md-12 padding-0 profilesidesss">
          <div className="panel bg-light-blue">
            <div className="panel-body text-white">
              <p className="animated fadeInUp quote">
                Digital Marketing Specialist | Front End Developer | Content
                Writer | Freelancer Dricki IT Solutions
              </p>
              <div className="col-md-12 padding-0">
                <div className="text-left col-md-7 col-xs-12 col-sm-7 padding-0">
                <a href="https://twitter.com/hero_gaur" id="twitter"> <span id="twitter" className="fa fa-twitter fa-2x" /></a>
                  <span>Rohtak, Haryana, India</span>
                </div>
                <div
                  style={{ paddingTop: 8 }}
                  className="text-right col-md-5 col-xs-12 col-sm-5 padding-0"
                >
                  <span className="fa fa-retweet" /> 2000
                  <span className="fa fa-star" /> 3000
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Profile;
